var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"data-test-id":"SettingsLinkComponent"},on:{"click":_vm.onSettingsClick}},[_c('span',{staticClass:"text-red"},[_vm._v("Settings")])])
}
var staticRenderFns = []

export { render, staticRenderFns }